import { Duration } from 'luxon';
export var TimeFormat;
(function (TimeFormat) {
    TimeFormat["Milliseconds"] = "milliseconds";
    TimeFormat["Seconds"] = "seconds";
    TimeFormat["Minutes"] = "minutes";
    TimeFormat["Hours"] = "hours";
})(TimeFormat || (TimeFormat = {}));
export default class TimeUtils {
    /**
     * Convert time from X to Y
     *
     * @param time Current time to be converted
     * @param fromFormat Starting time format
     * @param toFormat Ending time format
     * @param precision The precision of
     *
     * @return {number}
     */
    static convertTimeFromTo(time, fromFormat, toFormat, precision = 4) {
        const duration = Duration.fromObject({
            [fromFormat]: time // From time
        })
            .as(toFormat) // To time
            .toPrecision(precision); // Precision of digits
        return parseFloat(duration);
    }
}
//# sourceMappingURL=TimeUtils.js.map